import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilsService} from '@services/utils/utils.service';
import {MachineGroupTreeItem} from '@models/adminstration/machine-group/machine-group-tree-item';

@Component({
    selector: 'scitis-tree-list',
    templateUrl: './tree-list.component.html',
    standalone: false
})
export class TreeListComponent implements OnInit {
  @Input() listOptions?: any;
  @Input() isRootGroup: boolean = true;
  @Input() isRootAvailableToChange: boolean = false;
  @Input() whiteListedMachineryGroups: number[] = [];
  @Output() checkboxStatusEmitter = new EventEmitter<{event: any, item: MachineGroupTreeItem}>();

  public shownTreeDataStructure: any;
  public uniqueId: string = 'tree' + this.utils.generateUniqueId();

  constructor(
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.setTreeDataStructure();
  }

  public setTreeDataStructure() {
    if (this.isRootGroup) {
      this.shownTreeDataStructure = {children: [this.listOptions] as MachineGroupTreeItem[]} as MachineGroupTreeItem;
    } else {
      this.shownTreeDataStructure = this.listOptions;
    }
  }

  public onCheck(event: any, child: MachineGroupTreeItem) {
    if (this.whiteListedMachineryGroups?.length && !this.whiteListedMachineryGroups.includes(child.id)) {
      event.preventDefault();
      return;
    }

    child.checked = !child.checked;
    event.stopPropagation();
    this.checkboxStatusEmitter.emit({event: event, item: child});
  }

  public onSelectAll(child: MachineGroupTreeItem) {
    this.selectOrDeselectRecursively(child, true);
  }

  public onDeselectAll(child: MachineGroupTreeItem) {
    this.selectOrDeselectRecursively(child, false);
  }

  private selectOrDeselectRecursively(child: MachineGroupTreeItem, isSelect: boolean) {
    const event = {target: {checked: isSelect}};

    if (!child.disabled) {
      child.checked = isSelect;
      this.checkboxStatusEmitter.emit({event: event, item: child});
    }

    if (child?.children?.length) {
      for (const c of child?.children) {
        if (!c.disabled) {
          c.checked = isSelect;
          this.checkboxStatusEmitter.emit({event: event, item: c});
        }
        this.selectOrDeselectRecursively(c, isSelect);
      }
    }
  }

}
